// Tanggal LOKAL (WIB di perangkat user), bukan UTC — toISOString() menggeser tanggal -7 jam.
const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d = new Date()) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const ym = (d = new Date()) => ymd(d).slice(0, 7);
// Tanggal dari sel Excel (SheetJS cellDates) bisa bergeser beberapa detik/menit sebelum tengah malam
// akibat offset historis zona waktu → bulatkan dulu agar tidak mundur 1 hari.
export const xlsYmd = (d) => ymd(new Date(d.getTime() + 30 * 60 * 1000));
